import React, { useRef, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import "./shareCertificateWithSocial.scss";
import { ReactComponent as CopiedIcon } from "../../assets/icons/NewIcons/copiedIcon.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/NewIcons/exittIcon.svg";
import ShareBtnIcons from "../../assets/icons/UpdatedCheckoutPage/share-icon.png";
import Spinner from "../../reusableComponents/Spinner";
import { handleCopyToClipboard } from "../../utilities/string";
import { useSelector } from "react-redux";
import axios from "axios";
import { baseUrl } from "../../Axios";

const ShareCertiWithSocialmedia = ({ data }) => {
  const [shareDropdown, setShareDropdown] = useState(false);
  const [linkGenerated, setLinkGenerated] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const dropDownRef = useRef(null);

  const handleShare = () => setShareDropdown(true);
  const { ACCtoken } = useSelector((state) => state);
  const handleGenerate = async (isPublic) => {
    setButtonLoader(true);

    try {
      const formData = new FormData();
      formData.append("public", isPublic ? "False" : "True");

      const config = {
        headers: {
          Authorization: `Bearer ${ACCtoken}`,
        },
      };

      const result = await axios.put(
        `${baseUrl}/certificate/${data?.id}/`,
        formData,
        config
      );

      console.log(result?.data, "API Response");

      if (result?.status === 200) {
        // Use `result.data` to update `linkGenerated`
        const isLinkPublic = result?.data?.public === "True";
        setLinkGenerated(isLinkPublic);

        // Optionally update `data.public` if necessary
        data.public = isLinkPublic;
      } else {
        alert(`Failed to update link: ${result?.error || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error generating/disabling link:", error);
    } finally {
      setButtonLoader(false);
    }
  };

  const handleCopyLink = () => {
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };

  const shareUrl = `${window.location.origin}/share-certificates/${data?.id}`;

  return (
    <div>
      <div className="shareBtn" ref={dropDownRef}>
        <button onClick={handleShare}>
          <img src={ShareBtnIcons} alt="" />
        </button>

        {shareDropdown && (
          <div className="shareDropDown dropdownVisible">
            <div className="shareHeader">
              <span>Share</span>
              <button onClick={() => setShareDropdown(false)}>
                <CloseIcon />
              </button>
            </div>

            <div className="generateBtn">
              {!linkGenerated && !data?.public ? (
                <p>Link not generated. Please generate a link to share.</p>
              ) : (
                <>
                  <p>
                    {data?.public || linkGenerated
                      ? "Link generated. Copy and share it!"
                      : "Generate the link, copy it, and share!"}
                  </p>
                  {(data?.public || linkGenerated) && (
                    <p>You can disable the link anytime.</p>
                  )}
                </>
              )}

              <button
                className={
                  data?.public || linkGenerated ? "disable_btn" : "generate_btn"
                }
                onClick={() => handleGenerate(data?.public)}
                disabled={buttonLoader}
              >
                {buttonLoader ? (
                  <Spinner />
                ) : data?.public || linkGenerated ? (
                  "Disable"
                ) : (
                  "Generate"
                )}
              </button>
            </div>

            {(data?.public || linkGenerated) && (
              <>
                <div className="generatedLink">
                  <p>{shareUrl}</p>
                  <CopyToClipboard
                    text={shareUrl}
                    onCopy={handleCopyToClipboard}
                  >
                    <button onClick={handleCopyLink}>
                      {!linkCopied ? (
                        "Copy Link"
                      ) : (
                        <>
                          Copied <CopiedIcon />
                        </>
                      )}
                    </button>
                  </CopyToClipboard>
                </div>

                <div className="generatedLink social_icons">
                  <FacebookShareButton url={shareUrl}>
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                  <TwitterShareButton url={shareUrl}>
                    <XIcon size={32} round />
                  </TwitterShareButton>
                  <WhatsappShareButton url={shareUrl}>
                    <WhatsappIcon size={32} round />
                  </WhatsappShareButton>
                  <LinkedinShareButton url={shareUrl}>
                    <LinkedinIcon size={32} round />
                  </LinkedinShareButton>
                  <TelegramShareButton url={shareUrl}>
                    <TelegramIcon size={32} round />
                  </TelegramShareButton>
                  <RedditShareButton url={shareUrl}>
                    <RedditIcon size={32} round />
                  </RedditShareButton>
                  <EmailShareButton url={shareUrl}>
                    <EmailIcon size={32} round />
                  </EmailShareButton>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareCertiWithSocialmedia;
